module.exports = __webpack_public_path__ + "img/p2_r.7efd3b15.jpg";